/**
 * Returns all devices that match the current filter terms.
 * - returns all devices if no terms are set
 *
 * @param {import('src/models/Device').default[]} devices
 * @param {string} terms
 */
export function devicesMatchingTerms(devices, terms) {
  if (terms.length === 0) {
    return devices;
  }

  return devices.filter(({ assetName = '', serial = '', model = '' }) => {
    const deviceProps = [assetName, serial, model].map((property) => property.toLowerCase());
    return deviceProps.some((property) => terms.some((term) => property.includes(term)));
  });
}

/**
 * Returns true if the given device is considered an asset.
 *
 * @param {import('src/models/Device').default} device
 */
export function isAssetDevice({ serial }) {
  return serial.startsWith('QT') || serial.startsWith('QW');
}

/**
 * Returns true if the given device is considered a dashcam device.
 *
 * @param {import('src/models/Device').default} device
 */
export function isDashcamDevice({ serial }) {
  return serial.startsWith('1RV') || serial.startsWith('2RV');
}

/**
 * Returns true if the given device is considered a direct connect device.
 *
 * @param {import('src/models/Device').default} device
 */
export function isDirectConnectDevice({ model }) {
  return Boolean(model?.includes('Direct Connect'));
}

/**
 * Returns true if the given device does not fall into any other category (a catch all, OBD device is assumed).
 *
 * @param {import('src/models/Device').default} device
 */
export function isObdDevice(device) {
  return (
    !isAssetDevice(device) && !isDashcamDevice(device) && !isDirectConnectDevice(device) && !isOtherDeviceType(device)
  );
}

/**
 * Returns true if the given device falls into the "other" device type category.
 *
 * @param {import('src/models/Device').default} device
 */
export function isOtherDeviceType({ model }) {
  return Boolean(model?.includes('Bosch'));
}
